
import {defineComponent} from "vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import {AbilityContext} from "@/context/AbilityContext";

export default defineComponent({
  name: "PharmaPay",
  components: {
    BaseTitle, BaseContainer
  },
  data() {
    return {
      isAuthorized: AbilityContext.isAuthorizedForFeature('PAYMENT_TRANSACTION'),
    }
  },
  mounted() {

  },
});
